import React from "react";
import axios from 'axios'
import MobileStepper from '@material-ui/core/MobileStepper';
import Button from '@material-ui/core/Button';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import "./styleLogin.css";

// make to call to get user from redux or atom

export default class Register extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            activeStep: 0,
            plan: 'small',
            clientInfo: {},
            userInfo: {}
        };
    }

    componentDidMount = async () => {
        await axios.get('/api/isLoggedIn')
            .then(({ data }) => {
                if (data.loggedIn) {
                    window.location = "/";
                }
            })

    }

    loginInfo = (e) => {
        e.preventDefault();
        const value = e.target.value
        const name = e.target.name
        this.setState({
            [name]: value,
            userInfo: {
                ...this.state.userInfo,
                [name]: value
            }
        })
    }

    clientInfo = (e) => {
        e.preventDefault();
        const value = e.target.value
        const name = e.target.name
        this.setState({
            [name]: value,
            clientInfo: {
                ...this.state.clientInfo,
                [name]: value
            }
        })
    }

    confirmPassword = (e) => {
        e.preventDefault();
        const value = e.target.value
        const name = e.target.name
        //confirm password
        // this.setState({
        //     [name]: value
        // })
    }

    onSubmit = (e) => {
        e.preventDefault();
        const loginObject = {
            email: this.state.email,
            password: this.state.password,
            clientInfo: this.state.clientInfo,
            userInfo: this.state.userInfo
        }
        axios.post('/userRegister', loginObject)
            .then(({ data }) => {
                console.log(data)
                window.location = "/";
            })
            .catch(error => {
                console.log(error)
            })
    }



    handleNext = () => {
        document.getElementById("registerForm").reset();
        this.setState({
            activeStep: this.state.activeStep + 1
        })
    };

    sendToPayment = (e, plan, number) => {
        e.preventDefault();
        document.getElementById("registerForm").reset();
        console.log(`${plan}Pay`, document.getElementById(`${plan}Pay`).style)
        document.getElementById(`${this.state.plan}Pay`).style.background = 'white'
        this.setState({
            plan: plan,
            clientInfo: {
                ...this.state.clientInfo,
                plan: number
            }
        })
        document.getElementById(`${plan}Pay`).style.background = '#D4D3E8'
    }

    handleBack = () => {
        document.getElementById("registerForm").reset();
        this.setState({
            activeStep: this.state.activeStep - 1
        })
    };

    render() {
        return (
            <div class="container">
                <div class="screen">
                    <div class="screen__content">
                        <form class="register" id="registerForm">
                            {this.state.activeStep === 0 ? <div>
                                <h2 className="registerTag">User Info</h2>
                                <div class="register__field">
                                    <i class="login__icon fas fa-user"></i>
                                    <input type="text" class="login__input" required name='first' placeholder="First Name" value={this.state.first} onChange={(e) => this.loginInfo(e)} />
                                </div>
                                <div class="register__field">
                                    <i class="login__icon fas fa-user"></i>
                                    <input type="text" class="login__input" required name='last' placeholder="Last Name" value={this.state.last} onChange={(e) => this.loginInfo(e)} />
                                </div>
                                {/* geoLocate this */}
                                <div class="register__field">
                                    <i class="login__icon fas fa-user"></i>
                                    <input type="text" class="login__input" required name='title' value={this.state.title} placeholder="Job Title" onChange={(e) => this.loginInfo(e)} />
                                </div>
                                <div class="register__field">
                                    <i class="login__icon fas fa-user"></i>
                                    <input type="text" class="login__input" required name='email' value={this.state.email} placeholder="Email" onChange={(e) => this.loginInfo(e)} />
                                </div>
                                <div class="register__field">
                                    <i class="login__icon fas fa-lock"></i>
                                    <input type="password" class="login__input" required name='password' value={this.state.password} placeholder="Password" onChange={(e) => this.loginInfo(e)} />
                                </div>
                                <div class="register__field">
                                    <i class="login__icon fas fa-lock"></i>
                                    <input type="password" class="login__input" required name='confirm_password' value={this.state.confirm_password} placeholder="Confirm Password" onChange={(e) => this.confirmPassword(e)} />
                                </div>
                            </div> :
                                this.state.activeStep === 1 ? <div>
                                    <h2 className="registerTag">Client Info</h2>
                                    <div class="register__field">
                                        <i class="login__icon fas fa-user"></i>
                                        <input type="text" class="login__input" required name='clientName' placeholder="Client Name" value={this.state.clientName} onChange={(e) => this.clientInfo(e)} />
                                    </div>
                                    <div class="register__field">
                                        <i class="login__icon fas fa-user"></i>
                                        <input type="text" class="login__input" required name='ClientDescription' placeholder="Description" value={this.state.ClientDescription} onChange={(e) => this.clientInfo(e)} />
                                    </div>
                                    {/* geoLocate this */}
                                    <div class="register__field">
                                        <i class="login__icon fas fa-user"></i>
                                        <input type="text" class="login__input" required name='Address' value={this.state.Address} placeholder="Address" onChange={(e) => this.clientInfo(e)} />
                                    </div>
                                    <div class="register__field">
                                        <i class="login__icon fas fa-user"></i>
                                        <input type="text" class="login__input" required name='city' value={this.state.city} placeholder="City" onChange={(e) => this.clientInfo(e)} />
                                    </div>
                                    <div class="register__field">
                                        <i class="login__icon fas fa-user"></i>
                                        <input type="text" class="login__input" required name='State' value={this.state.State} placeholder="State" onChange={(e) => this.clientInfo(e)} />
                                    </div>
                                    <div class="register__field">
                                        <i class="login__icon fas fa-user"></i>
                                        <input type="text" class="login__input" required name='ZipCode' value={this.state.ZipCode} placeholder="ZipCode" onChange={(e) => this.clientInfo(e)} />
                                    </div>
                                </div> :
                                    this.state.activeStep === 2 ? <div>
                                        <div>
                                            Choose Plan
                                        </div>
                                        <button class="button login__submit paymentButton" id="smallPay" onClick={(e) => this.sendToPayment(e, "small", 1)}>
                                            <span class="button__text">Small - <span className="paymentDescription">Up to 3 Users</span></span>
                                            <span className="price">$100</span>
                                        </button>
                                        <button class="button login__submit paymentButton" id="mediumPay" onClick={(e) => this.sendToPayment(e, "medium", 2)}>
                                            <span class="button__text">Medium - <span className="paymentDescription">Up to 5 Users</span></span>
                                            <span className="price">$110</span>
                                        </button>
                                        <button class="button login__submit paymentButton" id="largePay" onClick={(e) => this.sendToPayment(e, "large", 3)}>
                                            <div>
                                                <span class="button__text">Large - <span className="paymentDescription">Up to 10 Users</span></span>
                                            </div>
                                            <span className="price">$120</span>

                                        </button>
                                    </div> :
                                        <div>
                                            <div class="register__field">
                                                <i class="login__icon fas fa-user"></i>
                                                <input class="login__input" required name='creditCard' type="tel" inputmode="numeric" pattern="[0-9\s]{13,19}" autocomplete="cc-number" maxlength="19" placeholder="xxxx xxxx xxxx xxxx" onChange={(e) => this.loginInfo(e)} />
                                            </div>
                                            <div class="register__field">
                                                <i class="login__icon fas fa-user"></i>
                                                <input type="date" class="login__input" required name='date' onChange={(e) => this.loginInfo(e)} />
                                            </div>
                                            {/* geoLocate this */}
                                            <div class="register__field">
                                                <i class="login__icon fas fa-user"></i>
                                                <input type="number" class="login__input" required name='securityCode' placeholder="XXX" onChange={(e) => this.loginInfo(e)} />
                                            </div>
                                            <button class="button login__submit" onClick={(e) => this.onSubmit(e)}>
                                                <span class="button__text">Pay & Register Now</span>
                                                <i class="button__icon fas fa-chevron-right"></i>
                                            </button>
                                        </div>
                            }
                            <MobileStepper
                                variant="dots"
                                steps={4}
                                position="static"
                                activeStep={this.state.activeStep}
                                className="stepperUi"
                                nextButton={
                                    <Button size="small" onClick={() => this.handleNext()} disabled={this.state.activeStep === 3}>
                                        <b>Next</b>
                                        <KeyboardArrowRight className="arrowColor" />
                                    </Button>
                                }
                                backButton={
                                    <Button size="small" onClick={() => this.handleBack()} disabled={this.state.activeStep === 0}>
                                        <KeyboardArrowLeft className="arrowColor" />
                                        <b>Back</b>
                                    </Button>
                                }
                            />

                        </form>
                    </div>
                    <div class="screen__background">
                        <span class="screen__background__shape screen__background__shape4"></span>
                        <span class="screen__background__shape screen__background__shape3"></span>
                        <span class="screen__background__shape screen__background__shape2"></span>
                        <span class="screen__background__shape screen__background__shape1"></span>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/auth/register.js